export default "__VITE_ASSET__Bqk2kpNg__"